import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './NotFound.module.css';

const NotFound = () => {
  const location = useLocation();
  const isNetworkError = location.state && location.state.isError;
  const customMessage = location.state && location.state.message;

  return (
    <main className={styles.errorPage}>
      <div className="container" style={{ textAlign: 'center', padding: '100px 20px', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div className={styles.iconCircle}>
          <svg viewBox="0 0 512 512" width="60" height="60" fill="currentColor">
            <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/>
          </svg>
        </div>
        <h1 className="section-title" style={{ marginTop: '30px', marginBottom: '15px' }}>
          {isNetworkError ? 'Oops! Something went wrong' : '404 - Page Not Found'}
        </h1>
        <p style={{ fontSize: '18px', color: 'var(--text-body)', maxWidth: '600px', marginBottom: '30px' }}>
          {isNetworkError 
            ? (customMessage || 'We encountered a network error while trying to process your request. Please check your connection and try again.')
            : 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'}
        </p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn-primary">Back to Home Page</Link>
          <a href="/contact" className="btn-ghost">Contact Support</a>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
